// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2dd5ba72","488":"0d7e8ced","667":"d36dc023","977":"3a05f912"}[chunkId] + ".chunk.js";
};